module.exports = __webpack_public_path__ + "img/wp-new-habit-card10.ef54d33e.jpg";